import { createSlice } from "@reduxjs/toolkit";
import { insightAdvancedReducer } from "./reducer";
import { initialState } from ".";
import { InsightsAdvancedTypes } from "./insightAdvanceTypes";
import {
  getInsightsAdvancedAction,
  getInsightsAdvancedExpenseAction,
  getInsightsAdvancedSalesAction,
  profitLossAction,
} from "./actions";

export const insightAdvanceSlice = createSlice({
  name: "insightAdvance",
  initialState,
  reducers: insightAdvancedReducer,
  extraReducers: {
    [getInsightsAdvancedAction.pending.toString()]: (
      state: InsightsAdvancedTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getInsightsAdvancedAction.fulfilled.toString()]: (
      state: InsightsAdvancedTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        insightsAdvancedListData: result,
      };
    },
    [getInsightsAdvancedAction.rejected.toString()]: (
      state: InsightsAdvancedTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [profitLossAction.pending.toString()]: (state: InsightsAdvancedTypes) => ({
      ...state,
      profitLossAction: true,
    }),
    [profitLossAction.fulfilled.toString()]: (
      state: InsightsAdvancedTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          profitLossAction: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        profitLossAction: false,
        statusCode: status_code,
        profitLossData: result,
      };
    },
    [profitLossAction.rejected.toString()]: (
      state: InsightsAdvancedTypes,
      { error }
    ) => ({
      ...state,
      profitLossAction: false,
      success: 0,
      error: error?.message,
    }),

    [getInsightsAdvancedSalesAction.pending.toString()]: (
      state: InsightsAdvancedTypes
    ) => ({
      ...state,
      totalSalesFetching: true,
    }),
    [getInsightsAdvancedSalesAction.fulfilled.toString()]: (
      state: InsightsAdvancedTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          totalSalesFetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        totalSalesFetching: false,
        statusCode: status_code,
        totelSales: result,
      };
    },
    [getInsightsAdvancedSalesAction.rejected.toString()]: (
      state: InsightsAdvancedTypes,
      { error }
    ) => ({
      ...state,
      totalSalesFetching: false,
      success: 0,
      error: error?.message,
    }),

    [getInsightsAdvancedExpenseAction.pending.toString()]: (
      state: InsightsAdvancedTypes
    ) => ({
      ...state,
      totalExpenseFetching: true,
    }),
    [getInsightsAdvancedExpenseAction.fulfilled.toString()]: (
      state: InsightsAdvancedTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          totalExpenseFetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        totalExpenseFetching: false,
        statusCode: status_code,
        totelExpense: result,
      };
    },
    [getInsightsAdvancedExpenseAction.rejected.toString()]: (
      state: InsightsAdvancedTypes,
      { error }
    ) => ({
      ...state,
      totalExpenseFetching: false,
      success: 0,
      error: error?.message,
    }),
  },
});

export const {
  resetInsightAdvancedError,
  resetInsightAdvancedSuccess,
  resetInsightAdvancedListData,
  resetInsightAdvancedFetching,
  resetProfiltLossData,
  resetTotelSales,
  resetTotalExpenses
} = insightAdvanceSlice.actions;
